import React from "react"
import { parseHtmlLinks } from "../../utils/functions"
import renderPaddingOrFullBleed from "../../utils/organism-formatting/renderPaddingOrFullBleed"
import RichText from "./RichText"

const RichTextConnector = ({
  data,
  location,
  isPageSection,
  nested,
  overrideTheme,
  proseText,
  marginTopAndBottom,
  includeClasses = true,
}) => {
  const richText = parseHtmlLinks(data?.content, location)

  const formatAssetHyperLinks = () => {
    let assetHyperLink = []
    if (JSON.parse(richText?.raw)?.content) {
      JSON.parse(richText?.raw)?.content?.forEach(item => {
        const linkedAsset = item?.content?.find(node => {
          return node?.nodeType === "asset-hyperlink"
        })

        if (linkedAsset && linkedAsset?.data?.target?.sys) {
          linkedAsset["assetId"] = linkedAsset?.data?.target?.sys?.id

          const addDetails = data.content.references.find(ref => {
            return ref.contentful_id === linkedAsset?.assetId
          })
          linkedAsset["file"] = addDetails?.file
          linkedAsset["link"] = {
            file: linkedAsset?.file?.url,
            text: linkedAsset?.content?.[0]?.value,
            id: linkedAsset?.data?.target?.sys?.id,
          }
        }

        if (linkedAsset && linkedAsset?.file) {
          assetHyperLink.push(linkedAsset)
        }
      })
    }
    return assetHyperLink
  }

  const parentColorScheme = data?.parentColorScheme || overrideTheme

  // by default richText does not have contentWidth as a prop. We add contentWidth in FullBackgroundHero so that this component does not have extra padding.
  const contentWidth =
    data?.contentWidth === false ? (isPageSection = false) : true
  return data?.content ? (
    isPageSection ? (
      renderPaddingOrFullBleed(
        <RichText
          contentfulId={data?.contentfulId ? data?.contentfulId : null}
          richText={richText}
          isChildContent={data?.isChildContent}
          parentColorScheme={parentColorScheme}
          colorScheme={data?.colorScheme}
          proseText={proseText}
          assetHyperLink={formatAssetHyperLinks()}
          includeClasses={includeClasses}
        />,
        true,
        true,
        true,
        nested,
        marginTopAndBottom
      )
    ) : (
      <RichText
        contentfulId={data?.contentfulId ? data?.contentfulId : null}
        richText={richText}
        isChildContent={data?.isChildContent}
        parentColorScheme={parentColorScheme}
        colorScheme={data?.colorScheme}
        proseText={proseText}
        assetHyperLink={formatAssetHyperLinks()}
        includeClasses={includeClasses}
      />
    )
  ) : null
}

export default RichTextConnector
